import { withCancellationToken } from "common/http/httpService";
import useAjaxCall from "common/ui/useAjaxCall";
import pageFilterService from "./pageFilter.service";
import { useCallback, useState } from "react";
import PageFilter from "./pageFilter";

const cachedFilters: {[pageName: string]: PageFilter} = {};

export default function usePageFilter(pageName?: string)
{
    const cacheKey = pageName ?? "_default";
    const [pageFilter, setPageFilter] = useState<PageFilter>(null);
    
    useAjaxCall(cxt => {
        if (cachedFilters[cacheKey] == null) {
            withCancellationToken(pageFilterService, cxt).getPageFilter(pageName)
                .then(m => {
                    const val = m ?? new PageFilter();
                    setPageFilter(val);
                    cachedFilters[cacheKey] = val;
                });
        }
        else {
            setPageFilter(cachedFilters[cacheKey]);
        }
    }, [pageName]);

    const update = useCallback(function(filter: PageFilter) {
        pageFilterService.updatePageFilter(filter, pageName);
        setPageFilter(filter);
        cachedFilters[cacheKey] = filter;
    }, [pageName]);

    return {
        isLoaded: pageFilter != null,
        filter: pageFilter,
        update
    }
}